@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-row justify-between mb-2 mt-4 px-2">
      <div class="flex flex-col flex-auto mb-2 mt-4 px-2">
        <div class="leading-6 font-medium">{{ field.label | localize }}</div>
        @if (field.hint) {
          <div class="text-md text-secondary">{{ field.hint | localize }}</div>
        }
        @if (!field.readonly &&
          field.control.touched &&
          field.control.errors) {
          @if (field.control.hasError('required')) {
            <div class="text-sm text-warn leading-none font-medium">
              {{ 'errorRequiredField' | transloco }}
            </div>
          }
          @if (field.control.hasError('minlength')) {
            <div class="text-sm text-warn leading-none font-medium">
              {{ 'errorMinLengthField' | transloco:{ requiredLength: field.control.errors.minlength.requiredLength } }}
            </div>
          }
          @if (field.control.hasError('maxlength')) {
            <div class="text-sm text-warn leading-none font-medium">
              {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength } }}
            </div>
          }
        }
      </div>
      <div class="flex flex-0">
        <button mat-flat-button class="mr-8" color="primary" (click)="addItem()" [disabled]="field.readonly || field.control.disabled">
          <mat-icon class="icon-size-5 mr-2" svgIcon="mat_outline:add"></mat-icon>
          {{ "add" | transloco }}
        </button>
      </div>
    </div>
  }
  <div [dndDropzone]="['outside']" [dndEffectAllowed]="'move'" (dndDrop)="drop($event)">
    <div dndPlaceholderRef class="outline outline-2 outline-dashed bg-primary-100 dark:bg-primary-900 outline-primary h-12 mx-2">
    </div>
    @for (embeddedForm of field.embeddedForms; track embeddedForm; let i = $index) {
      <div class="flex flex-row w-full p-4 mt-6 border-b" [dndDraggable]="field.control.value[i]" dndType="outside" [dndEffectAllowed]="'move'">
        @if (!field.readonly) {
          <div class="flex flex-col justify-center w-1/12">
            <button mat-icon-button (click)="removeItem(i)" [matTooltip]="'deleteItem' | transloco"
              [disabled]="field.readonly || field.control.disabled">
              <mat-icon class="icon-size-6" svgIcon="heroicons_outline:trash"></mat-icon>
            </button>
          </div>
        }
        <div class="flex flex-row flex-auto flex-wrap w-full">
          @for (column of embeddedForm.dType?.column; track column.name) {
            @if (embeddedForm.fields[column.name]; as field) {
              @if (!field.hidden) {
                @if (field.browserOpts?.newLine) {
                  <div class="w-full"></div>
                }
                                <dtype-item [ngClass]="{
                                        'w-full': field.browserOpts?.width === 'FULL' && field.type !== twoColumnsTable,
                                        'w-1/2': field.browserOpts?.width === 'HALF',
                                        'w-1/3': field.browserOpts?.width === 'THIRD',
                                        'w-2/3': field.browserOpts?.width === 'TWO_THIRDS',
                                        'w-1/4': field.browserOpts?.width === 'FOURTH',
                                        'w-3/4': field.browserOpts?.width === 'THREE_FOURTHS',
                                        'w-1/5': field.browserOpts?.width === 'FIFTH',
                                        'w-2/5': field.browserOpts?.width === 'TWO_FIFTH',
                                        'w-3/5': field.browserOpts?.width === 'THREE_FIFTHS',
                                        'w-4/5': field.browserOpts?.width === 'FOUR_FIFTHS',
                                        'w-1/6': field.browserOpts?.width === 'SIXTH',
                                        'w-5/6': field.browserOpts?.width === 'FIVE_SIXTHS',
                                        'px-2 py-2': !field.hidden && field.type !== embeddedItemUri && field.type !== embeddedItemCollectionUri
                                    }" [field]="field" [isUpdate]="isUpdate"></dtype-item>
              }
            }
          }
        </div>
        @if (!field.readonly && !field.control.disabled) {
          <div class="flex flex-col justify-center w-1/12">
            <mat-icon class="cursor-move icon-size-8" [svgIcon]="'mat_outline:drag_handle'" dndHandle></mat-icon>
          </div>
        }
      </div>
    }
  </div>
}
